// components/Common/Forms/RHFTextField.jsx
import { TextField, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

const RHFTextField = ({
  name,
  control,
  label,
  placeholder,
  required = false,
  endAdornment,
  startAdornment,
  type = "text",
  ...props
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <TextField
        {...field}
        fullWidth
        label={label}
        placeholder={placeholder}
        type={type}
        required={required}
        error={!!error}
        helperText={error?.message}
        InputProps={{
          endAdornment: endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : undefined,
          startAdornment: startAdornment ? (
            <InputAdornment position="start">{startAdornment}</InputAdornment>
          ) : undefined,
        }}
        {...props}
      />
    )}
  />
);

export default RHFTextField;
RHFTextField.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  endAdornment: PropTypes.node,
  startAdornment: PropTypes.node,
  type: PropTypes.string,
};
